exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cohorts-literal-new mp-query-entry-section {\n  display: block;\n  margin: 12px 0;\n}\n", ""]);

// exports
